import { render, staticRenderFns } from "./ManagementManagedServices.vue?vue&type=template&id=01dc0cca&scoped=true&"
import script from "./ManagementManagedServices.vue?vue&type=script&lang=ts&"
export * from "./ManagementManagedServices.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01dc0cca",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VStepperContent } from 'vuetify/lib/components/VStepper';
import { VStepperStep } from 'vuetify/lib/components/VStepper';
installComponents(component, {VStepperContent,VStepperStep})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01dc0cca')) {
      api.createRecord('01dc0cca', component.options)
    } else {
      api.reload('01dc0cca', component.options)
    }
    module.hot.accept("./ManagementManagedServices.vue?vue&type=template&id=01dc0cca&scoped=true&", function () {
      api.rerender('01dc0cca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/requirement/management-managed-services/views/ManagementManagedServices.vue"
export default component.exports